<template>
    <div>
        <div  class="BackToTop" v-show="goTopShow" @click="goTop">
        </div>
    </div>
</template>
<script>
export default {
  name: 'goTop',
  data () {
    return {
      scrollTop: '',
      goTopShow: false
    }
  },
  watch: {
    scrollTop (val) {
      if (this.scrollTop > 500) {
        this.goTopShow = true
      } else {
        this.goTopShow = false
      }
    }
  },
  methods: {
    handleScroll () {
      this.scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop
      if (this.scrollTop > 500) {
        this.goTopShow = true
      }
    },
    goTop () {
      let timer = null
      const _that = this
      cancelAnimationFrame(timer)
      timer = requestAnimationFrame(function fn () {
        if (_that.scrollTop > 0) {
          _that.scrollTop -= 50
          document.body.scrollTop = document.documentElement.scrollTop =
                        _that.scrollTop
          timer = requestAnimationFrame(fn)
        } else {
          cancelAnimationFrame(timer)
          _that.goTopShow = false
        }
      })
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped>
.BackToTop {
  position: fixed;
  bottom: 15px;
  right: 10px;
  width: 45.66666667px;
  height: 45.66666667px;
  font-size: 20px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIkAAACJCAMAAAAv+uv7AAAApVBMVEX///8AAADDw8N3d3dvb2++vr6Li4vr6+uWlpbOzs68vLzY2Njg4OD7+/u8vLy8vLy8vLzz8/O8vLzl5eX19fVeXl68vLy8vLz6+vrIyMiRkZG8vLy8vLza2tq8vLy8vLy8vLy8vLy8vLy8vLy8vLy9vb3k5OS8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLy8vLzR0dFlZWWgoKCEhISsrKxNTU28vLzh0xQbAAAANXRSTlOyAPXo7Pzdxdnm+trQtiPp07wUurX1bk+07dv38Nahm41oXjUJysvDv7arpZSCWS7C8dXhz8MLzDwAAASTSURBVHjaxNXpUtswFIbhg6gq5EVeSG0g+74n0Cnf/V9anTRFGSCC+DjO+8P/PPOMjha6KZvJs95iGkct7GpF8XTRy3JzU7ZSEjPojpvYJ4V43CWExL7muDtwcCqUpJtOhCKh/UAldFyiAl8LFEWdTXrjiC9J+zMAUrdVSKcKVVtLALO+A8OU5HMAwlf0dcoXAOa5/bk6SbqOdoyEvluyw0TrtGKJ6XqQWtF5KS3hdU2FEtPxINohnV/YFvA6piJJuiocAZUtKCyrtApJ1jo4OJZWxpYMY0g/JF6hLxEPWZJRz4NOiF+i4fVG5SXbGGJC1TQRiLdlJZkHHVJVhRpeVkoyWkIGVGWBxHJ0vsTEEAlVWyIQm3Mlw8gxGc6EouF5krwJny6Rj2Z+jmTg2CL8zTL4vqQPqehSKYm+Q8KAsChuyeBiEEsZfEeSXxBiKfnXkmHzghBLaQ6/kpgIAV2+AJFxS0YxfKojH/HIKVlCUz1pLF2SDCKkegoFstOSrScTqqtEettTklGMgOorQDw6IelBU51p9D6XDD0RUp2Fwht+KokxoXqbIP5MkkFT3WlkHyVpSyZUd4lspR8kK/hUfz5W7yXGvV3vn25Ld9dwblrzTtJxXiWNX6+Mbp2XSsdKDktCjsavrO7pdP8WxUq6CK4kCdA9lqTuJaGHF+Z0nIuSHknWaJOzxu+fpfvzQK7aWB9JIhnStQplZCU5NF0vjfxNMoei66Uw/y9JIeiaCaQHSZ950T88PzOv/P5BMkNCjO5fioPa4LyDmO0k7OHc71+CHw3ueArJBj4TwqX42OwlHSgehE1R6OwlkWRC+BQZ7SQGmgnhUzRMIRmgzYTwKW0MCkkXignhUxS6hWSMkAnhU0KMC0lT8CBPP/bfWxZFNG/IQPMgtJfcPbAoGoZy+DzIQUIsio+cMgQsyJuERQmQUQ+KA7ESFkWhRwskHIiVsCgJFjQFC2IlPAqmFEsWxEp4FBlTJFgQK+FRREQtwYJYCY8iWoRHFsRKeJRHFBIWxEoYFCthQKyEQbESBsRKGBQrYUCshEd5xDln5y+z9rKCMAxEYVgKVQM1SsVSEHTVvVqZ9380CVn8u9oxwsle8KOlucw5TyDLEijz+m/HsZ6cgXyTQHGsJ6fWIQGyKIFycayxjn1nyz8uS6C8HfuOZy+eXo/NGgk/d+zF3vOJQ+I9nwzWVSDpbEjn2Aok6RwbLVQgCRbTfacCSXPNd0C55GBTvhfLJTu751mBXJJnBdGCXBIs5pmSXNIembNpJMzZmD0KJcwee2vEksZ6ZtQSCTNq5vZCCXN7Xo9Awssh35FIyHfIvEQSMi9yQI2EHJBsVCMhGyUvFknIi8nQNRIydHoFIgm9AroWEklnN0f/pFiysn9CJ0cgoZPzj57SPkmm8p5SeXdrnHkkZd2t8j7b+HufrfKO36eZOyABAAAAEPT/dSsCf2RO9wi1oE4fCzXDUEcNteVObw8ZBMhlQFYF8juQaYKcF2TfIA8IGUnIjUKWVvLFkLmGHLpk86VfAfRwkL4W0utD+p9QTxjpk0O9g7afUoNfNZlQrBquAAAAAElFTkSuQmCC);
  background-size: cover;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  z-index: 10;
}
</style>
